import React from "react";
import { Card, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Div from "@jumbo/shared/Div";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import { useNavigate } from "react-router-dom";

const Item = ({ children, sx }) => (
  <Div sx={{ p: (theme) => theme.spacing(1, 2), ...sx }}>{children}</Div>
);

const UserListCard = ({ user, deleteUser }) => {
  const navigate = useNavigate();
  return (
    <Card sx={{ my: 1 }}>
      <Stack direction={"row"} alignItems={"center"} sx={{ p: 2 }}>
        <Item>
          <Avatar
            sx={{ width: 56, height: 56 }}
            alt={`${user.name}`}
            src={user?.imgUrl}
          />
        </Item>
        <Item
          sx={{
            flexBasis: "17%",
          }}
        >
          <Typography variant={"h6"} mb={0.5}>
            {user.name}
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            {user.email}
          </Typography>
        </Item>
        <Item
          sx={{
            flexBasis: "12%",
            marginRight: "auto",
          }}
        >
          <Typography variant={"h6"} mb={0.5}>
            {String(user.role).charAt(0).toLocaleUpperCase().concat(String(user.role).slice(1).toLowerCase())}
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            Função
          </Typography>
        </Item>
        <Item>
          <JumboDdMenu
            menuItems={[
              {
                title: "Visualizar",
                slug: "visualizar",
                onClickItem: () => {

                },
              },
              {
                title: "Editar",
                slug: "editar",
                onClickItem: () => {
                  navigate(`/usuario/${user.id}`);
                },
              },
              {
                title: "Excluir",
                slug: "Excluir",
                onClickItem: () => {
                  deleteUser(user.id);
                },
              },
            ]}
          />
        </Item>
      </Stack>
    </Card>
  );
};

export default UserListCard;
